// Copyright (c) Microsoft. All rights reserved.

import { IChatMessage } from '../../../libs/models/ChatMessage';
import { ISiteInfo } from '../../../libs/models/SelectedSites';
import { ChatState } from './ChatState';

export type Conversations = Record<string, ChatState>;

export interface ConversationsState {
    conversations: Conversations;
    selectedId: string;
    isLoadingMessages: boolean;
    isLoadingChats?: boolean;
    initialChatsLoaded?: boolean;
}

export const initialState: ConversationsState = {
    conversations: {},
    selectedId: '',
    isLoadingMessages: false,
    isLoadingChats: false,
    initialChatsLoaded: false,
};

export interface UpdateConversationPayload {
    id: string;
    messages: IChatMessage[];
}

export interface ConversationTitleChange {
    id: string;
    newTitle: string;
}

export interface ConversationScopeChange {
    id: string;
    newScope: string;
}

export interface ConversationSiteSourcesChange {
    id: string;
    siteSources: ISiteInfo[];
}

export interface ConversationAuthoritiveDocumentsChange {
    id: string;
    newDocuments: string[];
}

export interface ConversationSiteSourcesChange {
    id: string;
    siteSources: ISiteInfo[];
}

export interface ConversationInputChange {
    id: string;
    newInput: string;
}

export interface UpdatePluginStatePayload {
    id: string;
    pluginName: string;
    newState: boolean;
}
export interface ConversationHiddenStatusChange {
    id: string;
    newHiddenState: boolean;
}
export interface ConversationBotProfilePictureChange {
    id: string;
    newProfilePicture: string;
}
